import { useSnackbar } from 'notistack';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Field, FieldProps, useFormikContext } from 'formik';
import React, { ChangeEvent, FunctionComponent, useState, useEffect } from "react";
import useTSHacks from '../../shared/tshacks/tshacks';
import { Option } from "./Option";
import ApiService from '../../services/ApiService';
import { CodeListEntry } from "../../gen/api";


interface AdditionalProps {
  id: string
  fieldName: string
  fieldLabel: string
  required: boolean
  codeListName: string
}

type DynamicOptionFieldEditorProps = FieldProps & AdditionalProps;

const { getObjectProperty } = useTSHacks()

const DynamicOptionFieldEditor : FunctionComponent<DynamicOptionFieldEditorProps> = ({ id, required, fieldName, fieldLabel, codeListName, ...props }) => {

  const { enqueueSnackbar } = useSnackbar();

  const [blured,setBlured] = useState(false)

  const [options, setOptions] = useState<Option[]>([]);

  const { values, setFieldValue, errors, handleBlur} = useFormikContext();

  const getCodeListAsOptions = async (name: string): Promise<Array<Option>> => {
    try {
        return (await ApiService().fetchCodeListByName(name)).data.map(value => { return  {value: value.code, label: value.description}});
    } catch (e) {
        enqueueSnackbar('Unable to load code list: ' + name, { preventDuplicate:true, variant: 'error' });
    }
    return [];
  };

  const onBlur = (event: any) => {
      handleBlur(event)
      setBlured(true)
  }

  useEffect(() => {
    getCodeListAsOptions(codeListName)
        .then((opts) => {
            setOptions(opts);
        })
  }, []);


  return (
    <Autocomplete
      {...props}
      id={id}
      options={options}
      autoHighlight
      multiple={false}
      getOptionLabel={option => option?.label}
      value={options?.find(option => option.value === getObjectProperty(values,fieldName))||{ value: "", label: "" }}
      renderOption={option => (
        <React.Fragment>
          {option?.label}
        </React.Fragment>
      )}
      onChange={(event: ChangeEvent<{}>, value: Option | null) => {
          const safeValue=value||{ value: "", label: "" }
          setFieldValue(fieldName, safeValue.value,true)
      }}
      onBlur={onBlur}
      renderInput={props => (
        <Field
            {...props}
            helperText={blured && getObjectProperty(errors,fieldName)}
            error={blured && Boolean(getObjectProperty(errors,fieldName))}
            component={TextField}
            margin="dense"
            label={fieldLabel}
            variant="filled"
            type="text"
            name={fieldName}
            fullWidth
            required={required}
            InputLabelProps={{
                shrink: true,
            }}
        />
      )}
    />
  );
}

export default DynamicOptionFieldEditor;